export default class FieldDataModel {
  name: string;

  standard: boolean;

  ignore?: boolean;

  // false = configured for pulling, but the column has not landed in
  // Redshift yet. Only set when the pull config was fetched with
  // availability=true.
  isAvailable?: boolean;

  constructor(
    name?: string,
    standard?: boolean,
    ignore?: boolean,
    isAvailable?: boolean
  ) {
    if (name || standard) {
      this.name = name;
      this.standard = standard;
      this.ignore = ignore;
    } else {
      this.name = '';
      this.standard = false;
      this.ignore = false;
    }
    if (typeof isAvailable === 'boolean') {
      this.isAvailable = isAvailable;
    }
  }
}
